module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/projects/detail/project-detail-feed/project-detail-feed.component.scss
// module id = ./src/app/projects/detail/project-detail-feed/project-detail-feed.component.scss
// module chunks = main